const createExportUrl = (url: string): string => {
  const newUrl = new URL(url, window.location.origin);

  newUrl.searchParams.set('download', 'true');

  return newUrl.toString();
};

export default createExportUrl;
